import { useEffect } from 'react';
import { parse } from 'qs';
import {
  getRestoredSearchFilterStorage,
  updateFilterStorage,
} from '@/app/_components/feature/plp-srp-filter/filter-storage';
import { getPageKey } from '@/app/(pages)/results/utils/get-page-key';

/** 스크롤 복원을 반복적으로 체크하는 함수 */
const checkAndRestoreScroll = (scrollY: number, onComplete?: () => void) => {
  const start = Date.now();
  const intervalId = setInterval(() => {
    const elapsed = Date.now() - start;

    if (document.body.scrollHeight >= scrollY || elapsed >= 1000) {
      clearInterval(intervalId);
      window.scrollTo(0, scrollY);
      setTimeout(() => onComplete?.(), 500);
    }
  }, 10);
};

/** 스크롤 위치 복원 */
const restoreScrollPosition = (sessionKey: string, searchType: string | undefined, onComplete?: () => void) => {
  const pageKey = getPageKey();
  if (!pageKey) return;

  const scrollY = getRestoredSearchFilterStorage({ sessionKey })?.[pageKey]?.[searchType || 'all']?.scrollY ?? 0;

  if (scrollY > 0) {
    checkAndRestoreScroll(scrollY, onComplete);
  }
};

/** 스크롤 저장 + 복원 훅 */
export const useScrollRestoration = (sessionKey: string, searchType?: string, onComplete?: () => void) => {
  useEffect(() => {
    const pageKey = getPageKey();
    if (!pageKey) return;

    const currentQuery = parse(location.search.replace('?', ''));

    const saveScrollPosition = () => {
      updateFilterStorage({
        query: currentQuery,
        scrollY: window.scrollY,
        sessionKey,
        searchType,
        sessionPageKey: pageKey,
      });
    };

    restoreScrollPosition(sessionKey, searchType, onComplete);

    window.addEventListener('beforeunload', saveScrollPosition);
    return () => window.removeEventListener('beforeunload', saveScrollPosition);
  }, [searchType, sessionKey, onComplete]);
};
